// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"placeholder-f7uzC"};